<template>
  <v-container
    fluid
    fill-height
    fill-width
    class="Lmap"
  >
    <!-- MAP -->
    <l-map
      ref="map"
      id="map"
      :zoom="currentZoom"
      :center="currentCenter"
      :options="mapOptions"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      ></l-tile-layer>

      <v-marker-cluster :options="clusterOptions" ref="markerCluster">
        <l-marker
          v-for="item in locations"
          :key="item._id"
          :lat-lng="[item.lat, item.lng]"
          @click="info(item)"
        >
          <l-tooltip>
            {{ item.name | ReplaceStr("_"," - ") | Uppercase }}
          </l-tooltip>

          <l-icon
            :class-name="getMarkerClass(item)"
            :icon-size="iconSize"
            :icon-anchor="iconAnchor"
            :popup-anchor="popupAnchor"
          >
            <v-btn>
              <img :src="img(item)" />
            </v-btn>
          </l-icon>
        </l-marker>
      </v-marker-cluster>
    </l-map>
  
    <!-- Datatables -->
    <v-dialog
      transition="dialog-top-transition"
      max-width="1000"
      v-model="dialog"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>{{ name | ReplaceStr("_"," - ") | Uppercase }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <template v-slot:extension>
            <v-tabs
              v-model="tab"
              align-with-title
              class="breadcrumb"
            >
              <v-tabs-slider color="white"></v-tabs-slider>
              <v-tab>
                {{ $t('history').title1 }}
              </v-tab>
              <v-tab>
                {{ $t('history').title2 }}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>

        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="item in tabTitle"
            :key="item"
          >
            <!-- TAB DEVICE -->
            <v-card flat>
              <v-data-table
                v-if="(item != 'Historic')"
                :headers="header_devices"
                :items="devices"
                class="row-pointer"
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, 100, 250],
                  'showFirstLastPage': true,
                  'show-current-page': true,
                  'items-per-page-text':$t('vuetify-table').items_per_page_text
                }"
                :items-per-page="25"
                multi-sort
              >

                <template v-slot:item.sigfox="{ item }">
                  <v-chip>{{ item.sigfox }}</v-chip>
                </template>

              </v-data-table>


              <!-- TAB HISTORIC -->
              <v-data-table
                v-else
                :headers="headers"
                :items="products2"
                :options.sync="options"
                :server-items-length="totalProducts"
                :loading="loading"
                :loading-text="$t('history').loading"
                locale="pt"
                :footer-props="{
                  'items-per-page-options': [10,],
                  'showFirstLastPage': true,
                  'show-current-page': true,
                  'items-per-page-text':$t('vuetify-table').items_per_page_text
                }"
                :items-per-page="25"
                multi-sort
              >
                <template v-slot:item.datetime="{ item }">
                  {{ item.datetime | moment("DD/MM/YYYY - HH:mm:ss") }}
                </template>
              </v-data-table>


            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import store from '../store'
import Utils from "../mixins/UtilsMixin"
var qs = require('qs');

import L from "leaflet"
import { Icon } from "leaflet"
import { LMap, LIcon, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet'
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster"

import "../assets/css/MarkerCluster.css"
import "../assets/css/MarkerCluster.Default.css"

delete Icon.Default.prototype._getIconUrl
const markerRed = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjMsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhbWFkYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjM1cHgiIGhlaWdodD0iNDdweCIgdmlld0JveD0iMCAwIDM1IDQ3IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzNSA0NyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8ZyBpZD0iQ2FtYWRhX3gwMDIwXzEiPg0KCTxnIGlkPSJfMjQwNTg2NDQ4ODQzMiI+DQoJCTxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0xNy43LDkuODVjLTMuNiwwLTYuNSwzLTYuNSw2LjZzMi45LDYuNSw2LjUsNi41YzMuNiwwLDYuNi0yLjksNi42LTYuNVMyMS4zLDkuODUsMTcuNyw5Ljg1eiIvPg0KCQk8cGF0aCBmaWxsPSIjRkYwMDAwIiBkPSJNMTguMiwwLjk1QzUuNywwLjU1LTIuNywxMy44NSwzLjEsMjQuODVjMS42LDMsMy41LDUuODAxLDUuNCw4LjYwMWMyLjksNC4yLDYsOC4zOTksOS4yLDEyLjgNCgkJCWMwLjctMSwxLjMtMS42OTksMS44LTIuNWM0LjQtNS45LDguOS0xMS42OTksMTIuNS0xOC4xOTlDMzguMiwxNC42NSwzMC42LDEuMzUsMTguMiwwLjk1eiBNMTcuNywyNS4xNWMtNC44LDAtOC43LTMuOS04LjctOC43DQoJCQljMC00LjgsMy45LTguNyw4LjctOC43YzQuOCwwLDguNywzLjksOC43LDguN0MyNi40LDIxLjI1LDIyLjUsMjUuMTUsMTcuNywyNS4xNXoiLz4NCgkJPHBhdGggZmlsbD0ibm9uZSIgZD0iTTE3LjcsOS44NWMtMy42LDAtNi41LDMtNi41LDYuNnMyLjksNi41LDYuNSw2LjVjMy42LDAsNi42LTIuOSw2LjYtNi41UzIxLjMsOS44NSwxNy43LDkuODV6Ii8+DQoJCTxwYXRoIGZpbGw9IiM5MTAwMDAiIHN0cm9rZT0iI0QzMDAwMCIgZD0iTTE3LjcsNS40NWMtNiwwLTEwLjksNC45LTEwLjksMTFjMCw2LDQuOSwxMSwxMC45LDExYzYuMSwwLDExLTUsMTEtMTENCgkJCUMyOC43LDEwLjM1LDIzLjgsNS40NSwxNy43LDUuNDV6IE0xNy43LDI0Ljc1Yy00LjUsMC04LjMtMy44LTguMy04LjNjMC00LjYsMy44LTguMyw4LjMtOC4zYzQuNiwwLDguMywzLjcsOC4zLDguMw0KCQkJUzIyLjMsMjQuNzUsMTcuNywyNC43NXoiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg=='
const markerGreen = 'data:image/svg+xml;base64,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'
const markerBlack = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjMsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhbWFkYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjM1cHgiIGhlaWdodD0iNDdweCIgdmlld0JveD0iMCAwIDM1IDQ3IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzNSA0NyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBmaWxsPSJub25lIiBkPSJNMTcuNyw5Ljg1Yy0zLjYsMC02LjUsMy02LjUsNi42YzAsMy42LDIuOSw2LjUsNi41LDYuNWMzLjYsMCw2LjYtMi45LDYuNi02LjVDMjQuMywxMi44NSwyMS4zLDkuODUsMTcuNyw5Ljg1eg0KCSIvPg0KPHBhdGggZD0iTTE4LjIsMC45NUM1LjcsMC41NS0yLjcsMTMuODUsMy4xLDI0Ljg1YzEuNiwzLDMuNSw1LjgwMSw1LjQsOC42MDJjMi45LDQuMTk5LDYsOC4zOTgsOS4yLDEyLjhjMC43LTEsMS4zLTEuNjk4LDEuOC0yLjUNCgljNC40LTUuODk5LDguOS0xMS42OTgsMTIuNS0xOC4xOThDMzguMiwxNC42NSwzMC42LDEuMzUsMTguMiwwLjk1eiBNMTcuNywyNS4xNWMtNC44LDAtOC43LTMuOS04LjctOC43YzAtNC44LDMuOS04LjcsOC43LTguNw0KCWM0LjgsMCw4LjcsMy45LDguNyw4LjdDMjYuNCwyMS4yNSwyMi41LDI1LjE1LDE3LjcsMjUuMTV6Ii8+DQo8cGF0aCBmaWxsPSJub25lIiBkPSJNMTcuNyw5Ljg1Yy0zLjYsMC02LjUsMy02LjUsNi42YzAsMy42LDIuOSw2LjUsNi41LDYuNWMzLjYsMCw2LjYtMi45LDYuNi02LjVDMjQuMywxMi44NSwyMS4zLDkuODUsMTcuNyw5Ljg1eg0KCSIvPg0KPHBhdGggZmlsbD0iIzdBN0E3QSIgc3Ryb2tlPSIjMDAwMDAwIiBkPSJNMTcuNyw1LjQ1Yy02LDAtMTAuOSw0LjktMTAuOSwxMWMwLDYsNC45LDExLDEwLjksMTFjNi4xLDAsMTEtNSwxMS0xMQ0KCUMyOC43LDEwLjM1LDIzLjgsNS40NSwxNy43LDUuNDV6IE0xNy43LDI0Ljc1Yy00LjUsMC04LjMtMy44LTguMy04LjNjMC00LjYsMy44LTguMyw4LjMtOC4zYzQuNiwwLDguMywzLjcsOC4zLDguMw0KCUMyNiwyMS4wNSwyMi4zLDI0Ljc1LDE3LjcsMjQuNzV6Ii8+DQo8L3N2Zz4NCg=='
const markerBlue = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjMsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhbWFkYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjM1cHgiIGhlaWdodD0iNDdweCIgdmlld0JveD0iMCAwIDM1IDQ3IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzNSA0NyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8ZyBpZD0iXzI0MDU4NjQ0ODg0MzIiPg0KCTxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0xNy43LDkuODVjLTMuNiwwLTYuNSwzLTYuNSw2LjZzMi45LDYuNSw2LjUsNi41YzMuNiwwLDYuNi0yLjksNi42LTYuNVMyMS4zLDkuODUsMTcuNyw5Ljg1eiIvPg0KCTxwYXRoIGZpbGw9IiMwMDlFRkYiIGQ9Ik0xOC4yLDAuOTVDNS43LDAuNTUtMi43LDEzLjg1LDMuMSwyNC44NWMxLjYsMywzLjUsNS44MDEsNS40LDguNjAxYzIuOSw0LjIsNiw4LjM5OSw5LjIsMTIuOA0KCQljMC43LTEsMS4zLTEuNjk5LDEuOC0yLjVjNC40LTUuOSw4LjktMTEuNjk5LDEyLjUtMTguMTk5QzM4LjIsMTQuNjUsMzAuNiwxLjM1LDE4LjIsMC45NXogTTE3LjcsMjUuMTVjLTQuOCwwLTguNy0zLjktOC43LTguNw0KCQljMC00LjgsMy45LTguNyw4LjctOC43YzQuOCwwLDguNywzLjksOC43LDguN0MyNi40LDIxLjI1LDIyLjUsMjUuMTUsMTcuNywyNS4xNXoiLz4NCgk8cGF0aCBmaWxsPSJub25lIiBkPSJNMTcuNyw5Ljg1Yy0zLjYsMC02LjUsMy02LjUsNi42czIuOSw2LjUsNi41LDYuNWMzLjYsMCw2LjYtMi45LDYuNi02LjVTMjEuMyw5Ljg1LDE3LjcsOS44NXoiLz4NCgk8cGF0aCBmaWxsPSIjMDA4M0M0IiBzdHJva2U9IiMwMDk5RTUiIGQ9Ik0xNy43LDUuNDVjLTYsMC0xMC45LDQuOS0xMC45LDExYzAsNiw0LjksMTEsMTAuOSwxMWM2LjEsMCwxMS01LDExLTExDQoJCUMyOC43LDEwLjM1LDIzLjgsNS40NSwxNy43LDUuNDV6IE0xNy43LDI0Ljc1Yy00LjUsMC04LjMtMy44LTguMy04LjNjMC00LjYsMy44LTguMyw4LjMtOC4zYzQuNiwwLDguMywzLjcsOC4zLDguMw0KCQlTMjIuMywyNC43NSwxNy43LDI0Ljc1eiIvPg0KPC9nPg0KPC9zdmc+DQo='
//const markerOrange = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8IS0tIENyZWF0b3I6IENvcmVsRFJBVyBYNyAtLT4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNDVweCIgaGVpZ2h0PSI2MHB4IiB2ZXJzaW9uPSIxLjEiIHN0eWxlPSJzaGFwZS1yZW5kZXJpbmc6Z2VvbWV0cmljUHJlY2lzaW9uOyB0ZXh0LXJlbmRlcmluZzpnZW9tZXRyaWNQcmVjaXNpb247IGltYWdlLXJlbmRlcmluZzpvcHRpbWl6ZVF1YWxpdHk7IGZpbGwtcnVsZTpldmVub2RkOyBjbGlwLXJ1bGU6ZXZlbm9kZCINCnZpZXdCb3g9IjAgMCA0NTAgNjAwIg0KIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4NCiA8ZGVmcz4NCiAgPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCiAgIDwhW0NEQVRBWw0KICAgIC5zdHIwIHtzdHJva2U6I0Y0RTEyODtzdHJva2Utd2lkdGg6MTcuNzE2NX0NCiAgICAuZmlsMCB7ZmlsbDpub25lfQ0KICAgIC5maWwxIHtmaWxsOiNGQkU5MUZ9DQogICAgLmZpbDIge2ZpbGw6I0U4Q0QwM30NCiAgIF1dPg0KICA8L3N0eWxlPg0KIDwvZGVmcz4NCiA8ZyBpZD0iQ2FtYWRhX3gwMDIwXzEiPg0KICA8bWV0YWRhdGEgaWQ9IkNvcmVsQ29ycElEXzBDb3JlbC1MYXllciIvPg0KICA8ZyBpZD0iXzI0MDU3Mjc3NTcxMzYiPg0KICAgPHBhdGggY2xhc3M9ImZpbDAiIGQ9Ik0yMjggMTI0Yy00NiwwIC04NCwzOCAtODQsODQgMCw0NyAzOCw4NSA4NCw4NSA0NywwIDg1LC0zOCA4NSwtODUgMCwtNDYgLTM4LC04NCAtODUsLTg0eiIvPg0KICAgPHBhdGggY2xhc3M9ImZpbDEiIGQ9Ik0yMzQgOWMtMTYxLC01IC0yNjksMTY2IC0xOTQsMzA5IDIwLDM4IDQ0LDc0IDY5LDExMCAzOCw1NSA3OCwxMDkgMTE5LDE2NSA5LC0xMiAxNiwtMjEgMjQsLTMxIDU2LC03NyAxMTQsLTE1MiAxNjEsLTIzNSA3OSwtMTQyIC0xOCwtMzE0IC0xNzksLTMxOHptLTYgMzExYy02MSwwIC0xMTIsLTUwIC0xMTIsLTExMiAwLC02MiA1MSwtMTEyIDExMiwtMTEyIDYyLDAgMTEzLDUwIDExMywxMTIgMCw2MiAtNTEsMTEyIC0xMTMsMTEyeiIvPg0KICAgPHBhdGggY2xhc3M9ImZpbDAiIGQ9Ik0yMjUgMTI3Yy00NywwIC04NSwzOCAtODUsODUgMCw0NyAzOCw4NSA4NSw4NSA0NiwwIDg0LC0zOCA4NCwtODUgMCwtNDcgLTM4LC04NSAtODQsLTg1eiIvPg0KICAgPHBhdGggY2xhc3M9ImZpbDIgc3RyMCIgZD0iTTIyOCA2NmMtNzgsMCAtMTQxLDY0IC0xNDEsMTQyIDAsNzggNjMsMTQyIDE0MSwxNDIgNzksMCAxNDIsLTY0IDE0MiwtMTQyIDAsLTc4IC02MywtMTQyIC0xNDIsLTE0MnptMCAyNDljLTU5LDAgLTEwNywtNDggLTEwNywtMTA3IDAsLTU5IDQ4LC0xMDcgMTA3LC0xMDcgNTksMCAxMDgsNDggMTA4LDEwNyAwLDU5IC00OSwxMDcgLTEwOCwxMDd6Ii8+DQogIDwvZz4NCiA8L2c+DQo8L3N2Zz4NCg=='


export default {
  name: 'MapView',
  mixins: [Utils],
  components: {
    LMap,
    LTileLayer,
    LIcon,
    LMarker,
    LTooltip,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
  },
  data () {
    let locale = this.$i18n.locale
    
    //let tab_title = 'Devices'

    let evt_name = 'evt.name_en'
    let verbose_value = 'verbose_value_en'

    if (locale == 'pt'){
      evt_name = 'evt.name'
      verbose_value = 'verbose_value'
    }else if(locale == 'es'){
      evt_name = 'evt.name_es'
      verbose_value = 'verbose_value_es'
    }

    return {
      name: '',
      markerSelected: [],
      devices: [],
      iconSize:[50, 50],
      iconAnchor:[25, 50],
      popupAnchor:[0, -40],
      dialog: false,
      dialog_lengend: false,
      tab: null,
      tabTitle: ['Devices', 'Historic'],
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 3,
      currentCenter: [-15.219482, -53.41322],
      mapOptions: { zoomSnap: 0.5 },
      snackbar: false,
      text: '',
      markers: [],
      loading: true,
      options: {},
      headers: [
        {
          text: this.$i18n.messages[locale].history.type,
          align: 'start',
          value: evt_name,
        },
        {
          text: this.$i18n.messages[locale].history.datetime,
          value: 'datetime'
        },
        {
          text: this.$i18n.messages[locale].history.value,
          value: verbose_value
        },
      ],
      totalProducts: 0,
      products2: [],
      productSelected: null
    };
  },
  computed: {
    ...mapState('product', [
      'locations', 
      'products', 
      'updateLocations', 
      'eventsSelected',
    ]),
    clusterOptions() {
      return {
        iconCreateFunction: (cluster) => {
          const markers = cluster.getAllChildMarkers()
          let cls = 'gray'
          let clusterColor = "gray"
          let arr = []

          markers.forEach(marker => {
            const markerStatus = marker.options.icon.options.className;

            if (markerStatus == markerGreen){
              cls = 'green'
              clusterColor = "green"
            }else if (markerStatus == markerRed){
              cls = 'red'
              clusterColor = "red"
            }else if (markerStatus == markerBlue){
              cls = 'blue'
              clusterColor = "blue"
            }else if (markerStatus == markerBlack){
              cls = 'black'
              clusterColor = "black"
            }
            if(!arr.includes(cls))
              arr.push(cls)
          })

          if(arr.length > 1){
            cls = 'orange'
            clusterColor = "orange"
          }else if(arr.length == 1 && cls == 'black'){
            clusterColor = "black"
          }

          return L.divIcon({
            html: `<div class="${cls}" style="background-color: ${clusterColor}; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; color: white;">
                    ${cluster.getChildCount()}
                  </div>`,
          });
        },
      };
    },
    header_devices: {
      get: function () {
        let locale = this.$i18n.locale
        let h = this.$store.state.product.header[locale]
        let aux = []
        if (h != undefined) {
          h.forEach((el) => {
            let item = el.split('@')
            aux.push({ 'text': item[0], 'value': item[1] })
          })
        }
        return aux
      }
    },
  },
  watch: {
    // locations: {
    //   handler() {
    //     //this.currentZoom = 5
    //     //this.updateClusters();
    //   },
    //   deep: true,
    // },
    options: {
      handler () {
        this.loadHistory()
      },
      deep: true,
    },
    tab(){
      if(this.tab == 1){
        let locale = this.$i18n.locale
        this.loadHistory ()
        this.$set(this.headers[0], 'text', this.$i18n.messages[locale].history.type)
        this.$set(this.headers[1], 'text', this.$i18n.messages[locale].history.datetime)
        this.$set(this.headers[2], 'text', this.$i18n.messages[locale].history.value)
        let evt_name = 'evt.name_en'
        let verbose_value = 'verbose_value_en'
        if (locale == 'pt'){
          evt_name = 'evt.name'
          verbose_value = 'verbose_value'
        }else if(locale == 'es'){
          evt_name = 'evt.name_es'
          verbose_value = 'verbose_value_es'
        }
        this.$set(this.headers[0], 'value', evt_name)
        this.$set(this.headers[2], 'value', verbose_value)
      }
    },
    updateLocations () {
      this.update_devices()
      this.updateClusters()
    }
  },
  mounted () {
    document.getElementsByClassName('box-legend')[0].style.display='flex'
    store.dispatch('product/getLocations', null, { root: true })
      .then((res)=>{
        this.markers = res.locations
        setTimeout(() => { document.querySelector('.leaflet-marker-icon').click() }, 500)
      })
  },
  methods: {
    loadHistory () {
      this.loading = true;
      const { sortBy, sortDesc, page } = this.options
      const filter = this.eventsSelected.map((evt) => evt.code)
      Vue.axios.get(
        '/api/historic/', {
        params: {
          product: this.productSelected,
          page: page,
          page_size: 10,
          sortBy: sortBy,
          sortDesc: sortDesc,
          filter: filter
        },
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      }).then((data) => {
        const items = data.data;
        this.products2 = items.results;
        this.totalProducts = items.count;
        this.loading = false;
      })
    },
    getMarkerClass(marker) {
      if(marker.products.length > 0){
        const product = marker.products[0]
        if (!product.online)
          return markerBlack
        
        let count = product.status.length
        let evt = ''
        if(count > 0){
          product.status.forEach((sts)=>{
            if(sts.type_code == 6 || sts.type_code == 12)
              evt = (sts.value == 1)? markerRed : markerGreen
          })
          return evt
        }else{
          return markerBlue
        }
      }else{
        return markerBlue
      }
    },
    img(marker) {
      if(marker.products.length > 0){
        const product = marker.products[0]
        if (!product.online)
          return markerBlack
        
        let count = product.status.length
        let evt = ''
        if(count > 0){
          product.status.forEach((sts)=>{
            if(sts.type_code == 6 || sts.type_code == 12)
              evt = (sts.value == 1)? markerRed : markerGreen
          })
          return evt
        }else{
          return markerBlue
        }
      }else{
        return markerBlue
      }
    },
    updateClusters() {
      const markerCluster = this.$refs.markerCluster;
      if (markerCluster && markerCluster.mapObject) {
        // Remove all layers from the cluster
        markerCluster.mapObject.clearLayers();
        
        // Add markers back to the cluster
        this.markers.forEach(marker => {
          const markerObject = L.marker([marker.lat, marker.lng], {
            icon: L.divIcon({
              className: this.getMarkerClass(marker),
              html: `<v-btn>
                       <img src="${this.img(marker)}" />
                     </v-btn>`,
              markerStatus: marker.products[0].online ? "online" : "offline",
              iconSize: this.iconSize,
              iconAnchor: this.iconAnchor,
              popupAnchor: this.popupAnchor,
            }),
          });

          // Attach click event
          markerObject.on('click', () => {
            this.info(marker);
          });

          // Add tooltip to marker with custom styling
          const tooltip = L.tooltip({
            direction: 'right',
            offset: [10, 0]
          }).setContent(`<div class="arrow-right"></div>${marker.name.replace("_", " - ").toUpperCase()}`);
          markerObject.bindTooltip(tooltip);

          markerCluster.mapObject.addLayer(markerObject);
        });

        // Refresh the cluster
        markerCluster.mapObject.refreshClusters();
      }
    },
    toggleMarkerStatus() {
      // Example function to toggle the status of markers
      this.markers = this.markers.map(marker => ({
        ...marker,
        products: marker.products.map(product => ({
          ...product,
          online: !product.online,
        })),
      }));
    },
    update_devices () {
      let locale = this.$i18n.locale

      if (this.dialog == true) {
        let _id = this.markerSelected._id
        let loc = store.state.product.locations
        let idx = loc.findIndex(p => p._id == _id)
        this.devices = []

        loc[idx].products.forEach((p) => {
          if (p.status) {
            let obj = {}
            obj['sigfox'] = p.sigfox
            obj['typ'] = p.typ
            p.status.forEach((s) => {
              let value = s.type_code.toString()
              obj[value] = (locale == 'en') ? s.verbose_value_en : s.verbose_value
            })
            this.devices.push(obj)
          }
        })
      }
    },
    zoomUpdated (zoom) {
      this.currentZoom = zoom
      return true
    },
    centerUpdated (center) {
      this.currentCenter = center
      return true
    },
    info (item) {
      let locale = this.$i18n.locale
      this.devices = []
      this.markerSelected = item
      this.name = item.name
      this.productSelected = item.products[0]._id
      this.tab = 0

      store.state.product.locations.findIndex((l) => {
        if (l._id === item._id) {
          if (l.products.length > 0) {
            l.products.forEach((p) => {
              let obj = {}
              obj['sigfox'] = p.sigfox
              obj['typ'] = p.typ
              if (p.status) {
                p.status.forEach((s) => {
                  let value = s.type_code.toString()
                  obj[value] = (locale == 'en') ? s.verbose_value_en : s.verbose_value
                })
                this.devices.push(obj)
              }
            })
          }
        }
      })
      this.dialog = true
      this.loadHistory();
    },
  },
}
</script>

<style>
.leaflet-tooltip{
  position: absolute;
  position: relative !important; 
  padding: 10px !important; 
  border: none !important; 
  background-color: rgb(0, 0, 0) !important; 
  color: rgb(255, 255, 255) !important; 
  border: 0 !important; 
  -webkit-border-radius: 5px !important; 
  -moz-border-radius: 5px !important; 
  border-radius: 5px !important; 
  pointer-events: none !important; 
  box-shadow: 0 1px 3px rgba(6, 23, 78, 0.432) !important; 
}

.leaflet-tooltip-right:before {
    left: 0;
    margin-left: -12px;
    border-right-color: #000 !important;
}

.leaflet-tooltip-left:before {
    right: 0;
    margin-right: -12px !important;
    border-left-color: #000 !important;
}

/* .leaflet-marker-icon.marker-cluster.marker-cluster-small.leaflet-zoom-animated.leaflet-interactive{
  background-color: rgba(140, 209, 226, 0.6) !important;
}

.leaflet-marker-icon.marker-cluster.marker-cluster-small.leaflet-zoom-animated.leaflet-interactive > div {
  background-color: #26a6fd !important;
}

.leaflet-marker-icon.marker-cluster.marker-cluster-small.leaflet-zoom-animated.leaflet-interactive > div > span {
  color: #fff !important;
} */

.leaflet-div-icon{
  position: relative;
  width: 0;
  height: 0;
  border: 0;
  /* padding: 1px 0 0 0; */
}

.leaflet-div-icon > div{
  margin-top: -12px;
  margin-left: -12px;
}

.leaflet-marker-icon.leaflet-div-icon.leaflet-zoom-animated.leaflet-interactive > div.red{
  border:solid 5px #faafaf !important;
  /* background-color: rgba(140, 209, 226, 0.6) !important; */
}

.leaflet-marker-icon.leaflet-div-icon.leaflet-zoom-animated.leaflet-interactive > div.blue{
  border:solid 5px #9dc7f7 !important;
}

.leaflet-marker-icon.leaflet-div-icon.leaflet-zoom-animated.leaflet-interactive > div.green{
  border:solid 5px #a4d5a6 !important;
}

.leaflet-marker-icon.leaflet-div-icon.leaflet-zoom-animated.leaflet-interactive > div.orange{
  border:solid 5px #fde2c9a4 !important;
}

.leaflet-marker-icon.leaflet-div-icon.leaflet-zoom-animated.leaflet-interactive > div.gray{
  border:solid 5px #c4c4c4 !important;
}

.leaflet-marker-icon.leaflet-div-icon.leaflet-zoom-animated.leaflet-interactive > div.black{
  border:solid 5px #959595 !important;
}

#map {
  /* height: calc(100% - 10px) !important; */
  height: 100% !important;
  z-index: 8 !important;
}
.Lmap {
  height: 100%;
  padding: 0;
}
.Lmap .v-btn:not(.v-btn--round).v-size--default {
  min-width: 0px !important;
  padding: 0 5px;
}
.Lmap .theme--light.v-btn.v-btn--has-bg {
  background: transparent;
}
.Lmap .v-btn:before {
  background-color: transparent;
}
.Lmap .v-btn--is-elevated {
  box-shadow: none;
}
.Lmap .v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 0 !important;
}
.breadcrumb {
  background: #2782dd;
}
.modal-info {
  z-index: 9 !important;
}
.v-application .text-start {
  text-align: center !important;
}
table tbody tr:nth-child(odd) {
  background: #f6f6f6;
}
table tbody td {
  padding: 5px 0px !important;
  height: 66px;
}
table tbody td:nth-child(4) {
  text-transform: capitalize;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  animation: bgColor 400ms ease-in-out;
  background: #f1f1f1;
}
@keyframes bgColor {
  0% {
    background-color: transparent;
  }
  100% {
    background-color: #f1f1f1;
  }
}
</style>